export default __webpack_public_path__ + "img/raisin.asset.2332bcc3.jpg";